module.exports = __webpack_public_path__ + "static/media/sound.dc44ffcf.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/common/sound/static/sound.mp3
// module id = 193
// module chunks = 0